import { Typography } from '@material-ui/core'
import React from 'react'

import { TransactionHistory } from '../../../types/walletTransaction'
import PaymentStatusBox from '../PaymentStatusBox'
import StatusBox from '../StatusBox'
import useStyles from './styles/TransactionHistoryRow.styles'

interface TransactionHistoryRowProps {
  data: TransactionHistory
  //   showMetaData: boolean
  //   setshowMetaData: React.Dispatch<React.SetStateAction<boolean>>
}

const TransactionHistoryRow: React.FC<TransactionHistoryRowProps> = ({
  data
  //   setshowMetaData,
  //   showMetaData
}) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div>
          <Typography variant="body1">{data.createdAt}</Typography>
        </div>
        <div>
          <PaymentStatusBox status={data.paymentStatus} />
        </div>

        <div>
          <StatusBox status={data.status} />
        </div>
      </div>
    </>
  )
}
export default TransactionHistoryRow
